import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags ProductLists
 */
export const ExportImportInProductListExampleContentType = '' as const;
export type ExportImportInProductListExampleRequest = void;
export type ExportImportInProductListExampleResponses = LinkCommonErrorResponses & {
    '200': {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': string;
    };
};
export type ExportImportInProductListExampleResponseSuccess =
    ExportImportInProductListExampleResponses['200']['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
export type ExportImportInProductListExampleSearchParams = undefined;
export type ExportImportInProductListExamplePathParameters = undefined;
export const ExportImportInProductListExampleUrl = '/product-lists/variants/export/example' as const;
export const ExportImportInProductListExampleMethod = 'GET' as const;
export const getExportImportInProductListExampleUrl = (_params?: ExportImportInProductListExamplePathParameters) =>
    ExportImportInProductListExampleUrl;
